module.exports = __webpack_public_path__ + "img/defender.47568568.png";